import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorksAllFieldWorks(options = {}) {
  return _apiRequestWrap(
    ModulesMap.DONE_WORKS_ALL_FIELD_WORKS,
    ModulesConfigMap[ModulesMap.DONE_WORKS_ALL_FIELD_WORKS].GET_DONE_WORKS_ALL_FIELD_WORKS,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_ALL_FIELD_WORKS].GET_DONE_WORKS_ALL_FIELD_WORKS]: _getDoneWorksAllFieldWorks
}